import { useTranslation } from "react-i18next";
import { formatMass } from "../../components/utils/formatMass";
import { isAdminMode } from "../../components/utils/isAdminMode";

export const FilledStar = ({ size = 12 }) => (
  <svg
    width={size}
    height={(size * 11) / 12}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.70769 9.13333L2.94103 10.8C2.8188 10.8778 2.69103 10.9111 2.55769 10.9C2.42436 10.8889 2.30769 10.8444 2.20769 10.7667C2.10769 10.6889 2.02991 10.5917 1.97436 10.475C1.9188 10.3583 1.90769 10.2278 1.94103 10.0833L2.67436 6.93333L0.224359 4.81667C0.113248 4.71667 0.0438034 4.60278 0.0160256 4.475C-0.0117521 4.34722 -0.0034188 4.22222 0.0410256 4.1C0.0854701 3.97778 0.152137 3.87778 0.241026 3.8C0.329915 3.72222 0.452137 3.67222 0.607692 3.65L3.84103 3.36667L5.09103 0.4C5.14658 0.266667 5.23269 0.166667 5.34936 0.1C5.46603 0.0333333 5.58547 0 5.70769 0C5.82991 0 5.94936 0.0333333 6.06603 0.1C6.18269 0.166667 6.2688 0.266667 6.32436 0.4L7.57436 3.36667L10.8077 3.65C10.9632 3.67222 11.0855 3.72222 11.1744 3.8C11.2632 3.87778 11.3299 3.97778 11.3744 4.1C11.4188 4.22222 11.4271 4.34722 11.3994 4.475C11.3716 4.60278 11.3021 4.71667 11.191 4.81667L8.74103 6.93333L9.47436 10.0833C9.50769 10.2278 9.49658 10.3583 9.44103 10.475C9.38547 10.5917 9.30769 10.6889 9.20769 10.7667C9.10769 10.8444 8.99103 10.8889 8.85769 10.9C8.72436 10.9111 8.59658 10.8778 8.47436 10.8L5.70769 9.13333Z"
      fill="#1C1B1F"
    />
  </svg>
);

export const EmptyStar = ({ size = 12 }) => (
  <svg
    width={size}
    height={(size * 11) / 12}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.60769 8.83333L5.70769 7.56667L7.80769 8.85L7.25769 6.45L9.10769 4.85L6.67436 4.63333L5.70769 2.36667L4.74103 4.61667L2.30769 4.83333L4.15769 6.45L3.60769 8.83333ZM5.70769 9.13333L2.94103 10.8C2.8188 10.8778 2.69103 10.9111 2.55769 10.9C2.42436 10.8889 2.30769 10.8444 2.20769 10.7667C2.10769 10.6889 2.02991 10.5917 1.97436 10.475C1.9188 10.3583 1.90769 10.2278 1.94103 10.0833L2.67436 6.93333L0.224359 4.81667C0.113248 4.71667 0.0438034 4.60278 0.0160256 4.475C-0.0117521 4.34722 -0.0034188 4.22222 0.0410256 4.1C0.0854701 3.97778 0.152137 3.87778 0.241026 3.8C0.329915 3.72222 0.452137 3.67222 0.607692 3.65L3.84103 3.36667L5.09103 0.4C5.14658 0.266667 5.23269 0.166667 5.34936 0.1C5.46603 0.0333333 5.58547 0 5.70769 0C5.82991 0 5.94936 0.0333333 6.06603 0.1C6.18269 0.166667 6.2688 0.266667 6.32436 0.4L7.57436 3.36667L10.8077 3.65C10.9632 3.67222 11.0855 3.72222 11.1744 3.8C11.2632 3.87778 11.3299 3.97778 11.3744 4.1C11.4188 4.22222 11.4271 4.34722 11.3994 4.475C11.3716 4.60278 11.3021 4.71667 11.191 4.81667L8.74103 6.93333L9.47436 10.0833C9.50769 10.2278 9.49658 10.3583 9.44103 10.475C9.38547 10.5917 9.30769 10.6889 9.20769 10.7667C9.10769 10.8444 8.99103 10.8889 8.85769 10.9C8.72436 10.9111 8.59658 10.8778 8.47436 10.8L5.70769 9.13333Z"
      fill="#1C1B1F"
    />
  </svg>
);

const SortingErrorsIcon = () => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.46667 4.8L6.95 2.35L5.96667 0.716667C5.83333 0.494444 5.64167 0.383333 5.39167 0.383333C5.14167 0.383333 4.95 0.494444 4.81667 0.716667L3.18333 3.43333L5.46667 4.8ZM11.9167 9.33333L10.4333 6.86667L12.75 5.53333L13.8167 7.31667C13.9389 7.50556 14.0056 7.71667 14.0167 7.95C14.0278 8.18333 13.9778 8.4 13.8667 8.6C13.7556 8.82222 13.5917 9 13.375 9.13333C13.1583 9.26667 12.9222 9.33333 12.6667 9.33333H11.9167ZM10 14L7.33333 11.3333L10 8.66667V10H13.1667L12.2 11.9333C12.0778 12.1556 11.9111 12.3333 11.7 12.4667C11.4889 12.6 11.2556 12.6667 11 12.6667H10V14ZM3.55 12.6667C3.32778 12.6667 3.125 12.6083 2.94167 12.4917C2.75833 12.375 2.62222 12.2222 2.53333 12.0333C2.44444 11.8556 2.40278 11.6694 2.40833 11.475C2.41389 11.2806 2.46667 11.1 2.56667 10.9333L3.13333 10H6V12.6667H3.55ZM1.9 10.7667L0.816667 8.6C0.716667 8.4 0.669444 8.18611 0.675 7.95833C0.680556 7.73056 0.744445 7.51667 0.866667 7.31667L1.13333 6.86667L0 6.18333L3.65 5.26667L4.56667 8.93333L3.41667 8.23333L1.9 10.7667ZM10.9 5.06667L7.25 4.15L8.4 3.46667L6.31667 0H8.66667C8.9 0 9.11945 0.0583333 9.325 0.175C9.53056 0.291667 9.69445 0.45 9.81667 0.65L10.6833 2.1L11.8167 1.4L10.9 5.06667Z"
      fill="#222222"
    />
  </svg>
);

const SortingQualityFooter = ({
  isLoading = false,
  numberOfAnomaly,
  numberOfStars,
  totalWasteVolume,
  totalVolumeSortingError,
  totalMassSortingError,
  horizontalPaddingClassName = "mx-6",
}) => {
  const { t } = useTranslation();

  const percentage =
    !isLoading &&
    totalWasteVolume !== undefined &&
    totalVolumeSortingError !== undefined
      ? Math.round((totalVolumeSortingError * 100) / totalWasteVolume)
      : null;

  const isValidPercentage = percentage !== null && !isNaN(percentage);

  const massDisplay =
    isAdminMode() && totalMassSortingError != null && totalMassSortingError > 0
      ? ` - ${formatMass(totalMassSortingError)}`
      : "";

  return (
    <div
      className={`flex items-center justify-between py-4 border-t-[1.2px] border-[#D3D3D3] ${horizontalPaddingClassName} ${
        !isValidPercentage || isLoading || numberOfAnomaly === undefined
          ? "opacity-50"
          : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <SortingErrorsIcon />
        <span className="text-sm text-gray-700">
          {!isLoading && numberOfAnomaly !== undefined
            ? `${numberOfAnomaly ?? 0} ${(numberOfAnomaly ?? 0) > 1 ? t("sorting_errors") : t("sorting_error")}`
            : "..."}
        </span>
      </div>

      <div className="flex items-center gap-2">
        <div className="flex items-center gap-0.5">
          {[1, 2, 3].map((star) => (
            <div key={star}>
              {!isLoading &&
              numberOfStars !== undefined &&
              star <= (numberOfStars ?? 0) ? (
                <FilledStar />
              ) : (
                <EmptyStar />
              )}
            </div>
          ))}
        </div>
        <span className="text-sm font-bold text-gray-900">
          {isValidPercentage
            ? `${percentage}% ${t("of undesirables")}${massDisplay}`
            : "..."}
        </span>
      </div>
    </div>
  );
};

export default SortingQualityFooter;
